export default "__VITE_ASSET__25479dc6__"